import { render, staticRenderFns } from "./CustomQuiz.vue?vue&type=template&id=34596e0c&scoped=true&"
import script from "./CustomQuiz.vue?vue&type=script&lang=js&"
export * from "./CustomQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34596e0c",
  null
  
)

export default component.exports